import React, {Component} from 'react'

class PortfolioGrid extends Component {
  render() {


    return (
      <section id={this.props.data.id}>
        <div className='container'>
          <h2>{this.props.data.title}</h2>
          <p>{this.props.data.summary}</p>
      </div>
    </section>
    )
  }
}

export default PortfolioGrid



// WEBPACK FOOTER //
// ./src/Components/PortfolioGrid/index.js